<template>
  <div
    class="el-space"
    :class="[spaceClass]"
    :style="{ 'align-items': alignment }"
  >
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'ELSpace',
  props: {
    direction: {
      type: String,
      default: 'horizontal' // vertical
    },
    alignment: {
      type: String,
      default: 'center'
    },
    wrap: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    spaceClass() {
      const directionClass =
        this.direction === 'vertical'
          ? 'el-space--vertical'
          : 'el-space--horizontal'
      const wrapClass = this.wrap ? '' : 'nowrap'
      const finalClass = `${directionClass} ${wrapClass}`
      return finalClass
    }
  }
}
</script>

<style lang="scss">
.el-space {
  display: flex;
  flex-wrap: wrap;
  vertical-align: top;
  padding-bottom: 8px;
  margin-right: 8px;
  align-items: center;
  &.nowrap {
    flex-wrap: nowrap;
  }
}
.el-space--vertical {
  flex-direction: column;
}
.gap-small {
  padding-bottom: 0px;
  margin-right: 8px;
}
.gap-default {
  padding-bottom: 0px;
  margin-right: 12px;
}
</style>
